import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "indicator"]

  connect() {
    this.frame = null
    this.update()
  }

  disconnect() {
    if (this.frame) cancelAnimationFrame(this.frame)
  }

  update() {
    if (this.frame) cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => {
      const activeIndex = this.cardTargets.reduce((nearest, card, index) => {
        const distance = Math.abs(card.offsetLeft - this.element.scrollLeft)
        return distance < nearest.distance ? {index, distance} : nearest
      }, {index: 0, distance: Number.POSITIVE_INFINITY}).index

      const indicators = this.indicatorTargets.length > 0
        ? this.indicatorTargets
        : this.element.nextElementSibling?.querySelectorAll("[data-dwm-pricing-rail-target~='indicator']") || []

      indicators.forEach((indicator, index) => {
        indicator.classList.toggle("is-active", index === activeIndex)
      })
    })
  }
}
